var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.999,
    height: 16,
    viewBox: "0 0 15.999 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit_-_Copy",
    "data-name": "edit - Copy",
    transform: "translate(-16.19 -18.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13856",
    "data-name": "Path 13856",
    d: "M122.831.98a2.454,2.454,0,0,0-3.471,0l-9.73,9.73a.545.545,0,0,0-.14.24l-1.28,4.62a.545.545,0,0,0,.671.671l4.62-1.28a.545.545,0,0,0,.24-.14l9.73-9.731a2.457,2.457,0,0,0,0-3.471ZM110.818,11.065,118.782,3.1l2.568,2.568-7.964,7.964Zm-.513,1.029,2.052,2.052-2.838.786ZM122.7,4.319l-.578.578-2.569-2.569.579-.578a1.363,1.363,0,0,1,1.928,0l.64.64A1.365,1.365,0,0,1,122.7,4.319Zm0,0",
    transform: "translate(-92 18)",
    fill: "#777"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.05e2bed0ab87f1c558aa7961345371e9.svg";
export { ForwardRef as ReactComponent };